import request from "helper/request";

const billingApi = {
  // System Settings
  getAutoGenerateInvoicesNightly: () => {
    return request.get("admin/billing/settings/auto-generate-invoices-nightly");
  },

  setAutoGenerateInvoicesNightly: (enabled) => {
    return request.put("admin/billing/settings/auto-generate-invoices-nightly", {
      enabled
    });
  },

  getAutoGenerateInvoicesWeekly: () => {
    return request.get("admin/billing/settings/auto-generate-invoices-weekly");
  },

  setAutoGenerateInvoicesWeekly: (enabled) => {
    return request.put("admin/billing/settings/auto-generate-invoices-weekly", {
      enabled
    });
  },

  getAutoGenerateInvoicesMonthlyEntitlements: () => {
    return request.get(
      "admin/billing/settings/auto-generate-invoices-monthly-entitlements"
    );
  },

  setAutoGenerateInvoicesMonthlyEntitlements: (enabled) => {
    return request.put(
      "admin/billing/settings/auto-generate-invoices-monthly-entitlements",
      {
        enabled
      }
    );
  },

  // Routes for Invoice Generation
  getManagedRoutesForInvoice: (
    startDate,
    endDate,
    completedOnly = true,
    clientId = null
  ) => {
    return request.get("admin/facturas/managed-routes-for-invoice", {
      params: { startDate, endDate, completedOnly, clientId }
    });
  },

  // Pool Invoice Generation
  getPoolPackagesForInvoice: (startDate, endDate, statuses = [], clientId = null) => {
    return request.get("admin/facturas/pool-packages-for-invoice", {
      params: { startDate, endDate, statuses: statuses.join(","), clientId }
    });
  },

  generatePoolInvoices: (
    startDate,
    endDate,
    statuses = [],
    emailClients = true,
    clientId = null
  ) => {
    return request.post("admin/facturas/generate-pool-invoices", {
      startDate,
      endDate,
      statuses,
      emailClients,
      clientId
    });
  },

  generateEntitlementsInvoices: (startDate, endDate) => {
    return request.post("admin/billing/generate/entitlements", {
      startDate,
      endDate
    });
  },

  // Generate managed routes invoices
  generateManagedRoutesInvoices: (
    startDate,
    endDate,
    completedOnly = true,
    emailClients = true,
    clientId = null
  ) => {
    return request.post("admin/facturas/generate-managed-routes-invoices", {
      startDate,
      endDate,
      completedOnly,
      emailClients,
      clientId
    });
  },

  // Email receivables summary to client
  emailReceivablesSummary: (clientId, clientName, accountingEmail) => {
    return request.post("admin/billing/email-receivables-summary", {
      clientId,
      clientName,
      accountingEmail
    });
  },

  // SaaS Invoice Generation
  getSaasItemsForInvoice: (startDate, endDate, clientId = null) => {
    return request.get("admin/facturas/saas-items-for-invoice", {
      params: { startDate, endDate, clientId }
    });
  },

  generateSaasInvoices: (
    startDate,
    endDate,
    proRated = true,
    emailClients = true,
    clientId = null
  ) => {
    return request.post("admin/facturas/generate-saas-invoices", {
      startDate,
      endDate,
      proRated,
      emailClients,
      clientId
    });
  }
};

export default billingApi;
